import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const PRCNG_1079_I18N_NAMESPACE =
  '@mc/next/experiments/prcng-1079_v1_remove_refund_copy'

export const i18nInstance = registerI18nResources({
  namespace: PRCNG_1079_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
